module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst fieldConfig           = model.config || {}\nconst buttonNeutral         = fieldConfig.style === 'neutral'\nconst additionalClasses = []\nif(model.fullScreen)                    additionalClasses.push('fullScreen');\nif(model.isDirty)                       additionalClasses.push('isDirty');\nif(fieldConfig.isSingleElementSlim)     additionalClasses.push('isSingleElementSlim');\nif(fieldConfig.style)                   additionalClasses.push(fieldConfig.style);\nconst nrOfImages    = utils.collectionSize(model.dataJSON)\nconst preventImages = fieldConfig.showImages === false && !model.fullScreen\nlet fullScreenButtonType = 'fullScreen'\nif(model.fullScreen){\nfullScreenButtonType = 'closeFullScreen'\n}\nconst grantedButtons = {\nassign:         !preventImages,\nassignFiltered: !preventImages && !fieldConfig.isSingleElementSlim,\nrenew:          !preventImages && model.extendedButtonActionsGranted,\ndelete:         !preventImages,\nfullScreen:     !fieldConfig.isSingleElementSlim,\n}\n%><div data-field-code=\"<%- model.fieldCode || '' %>\" class=\"<%= additionalClasses.join(' '); %>\"><%\n%><div class=\"controls\"><%\nif(grantedButtons.assign){\nconst buttonFormMapping = formMapping\nbuttonFormMapping.neutral = buttonNeutral\n%><%- include('./image-button', { formMapping: buttonFormMapping, model: model, config: config }); %><%\n}\nif(grantedButtons.assignFiltered){\n%><%- include('../elements/buttons/default', { formMapping: { buttonType: 'filter', context: 'media-image', symbolOnly: !model.fullScreen, neutral: buttonNeutral } }); %><%\n}\nif(grantedButtons.renew){\n%><%- include('../elements/buttons/default', { formMapping: { buttonType: 'renew', context: 'media-image', symbolOnly: !model.fullScreen, neutral: buttonNeutral } }); %><%\n}\nif(grantedButtons.delete){\n%><%- include('../elements/buttons/default', { formMapping: { buttonType: 'delete', context: 'media-image', symbolOnly: !model.fullScreen, neutral: buttonNeutral } }); %><%\n}\nif(grantedButtons.fullScreen){\n%><%- include('../elements/buttons/default', { formMapping: { buttonType: fullScreenButtonType, context: 'media-image', symbolOnly: !model.fullScreen, neutral: buttonNeutral } }); %><%\n}\n%></div><%\nif(!fieldConfig.isSingleElementSlim){\n%><div class=\"notices\">\n<div class=\"notice dirty\"><%= __('hint.imageField.dirty') %></div><%\nif(nrOfImages <= 0) {\n%><div class=\"notice\"><%= __('hint.imageField.empty') %></div><%\n} else if(preventImages) {\n%><div class=\"notice\"><%= __('hint.imageField.hiddenImages', { nrOfElements: nrOfImages }) %></div><%\n}\n%></div><%\n}\n%><div class=\"mediaContainer\">\n<div class=\"media\"><%\nif(!preventImages){\nif(nrOfImages > 0) {\nutils.forEach(model.dataJSON, function(image){\n%><%- include('../media/image/image', { resourceData: image, config: { context: 'assignment' }, model: { extendedButtonActionsGranted: model.extendedButtonActionsGranted } }); %><%\n});\n} else if(fieldConfig.renderPlaceholder) {\n%><%- include('../media/image/image', { resourceData: {}, config: { context: 'assignment' }, model: { extendedButtonActionsGranted: model.extendedButtonActionsGranted } }); %><%\n}\n}\n%></div>\n</div>\n</div>"
  , __filename = "..\\..\\npm\\frontend-controller\\baseComponents\\form\\fields\\image.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const fieldConfig           = model.config || {}
const buttonNeutral         = fieldConfig.style === 'neutral'
const additionalClasses = []
if(model.fullScreen)                    additionalClasses.push('fullScreen');
if(model.isDirty)                       additionalClasses.push('isDirty');
if(fieldConfig.isSingleElementSlim)     additionalClasses.push('isSingleElementSlim');
if(fieldConfig.style)                   additionalClasses.push(fieldConfig.style);
const nrOfImages    = utils.collectionSize(model.dataJSON)
const preventImages = fieldConfig.showImages === false && !model.fullScreen
let fullScreenButtonType = 'fullScreen'
if(model.fullScreen){
fullScreenButtonType = 'closeFullScreen'
}
const grantedButtons = {
assign:         !preventImages,
assignFiltered: !preventImages && !fieldConfig.isSingleElementSlim,
renew:          !preventImages && model.extendedButtonActionsGranted,
delete:         !preventImages,
fullScreen:     !fieldConfig.isSingleElementSlim,
}

    ; __line = 22
    ; __append("<div data-field-code=\"")
    ; __append( model.fieldCode || '' )
    ; __append("\" class=\"")
    ; __append(escapeFn( additionalClasses.join(' ') ))
    ; __append("\">")
    ; 

    ; __line = 23
    ; __append("<div class=\"controls\">")
    ; 
if(grantedButtons.assign){
const buttonFormMapping = formMapping
buttonFormMapping.neutral = buttonNeutral

    ; __line = 27
    ; __append( include('./image-button', { formMapping: buttonFormMapping, model: model, config: config }) )
    ; 
}
if(grantedButtons.assignFiltered){

    ; __line = 30
    ; __append( include('../elements/buttons/default', { formMapping: { buttonType: 'filter', context: 'media-image', symbolOnly: !model.fullScreen, neutral: buttonNeutral } }) )
    ; 
}
if(grantedButtons.renew){

    ; __line = 33
    ; __append( include('../elements/buttons/default', { formMapping: { buttonType: 'renew', context: 'media-image', symbolOnly: !model.fullScreen, neutral: buttonNeutral } }) )
    ; 
}
if(grantedButtons.delete){

    ; __line = 36
    ; __append( include('../elements/buttons/default', { formMapping: { buttonType: 'delete', context: 'media-image', symbolOnly: !model.fullScreen, neutral: buttonNeutral } }) )
    ; 
}
if(grantedButtons.fullScreen){

    ; __line = 39
    ; __append( include('../elements/buttons/default', { formMapping: { buttonType: fullScreenButtonType, context: 'media-image', symbolOnly: !model.fullScreen, neutral: buttonNeutral } }) )
    ; 
}

    ; __line = 41
    ; __append("</div>")
    ; 
if(!fieldConfig.isSingleElementSlim){

    ; __line = 43
    ; __append("<div class=\"notices\">\n<div class=\"notice dirty\">")
    ; __line = 44
    ; __append(escapeFn( __('hint.imageField.dirty') ))
    ; __append("</div>")
    ; 
if(nrOfImages <= 0) {

    ; __line = 46
    ; __append("<div class=\"notice\">")
    ; __append(escapeFn( __('hint.imageField.empty') ))
    ; __append("</div>")
    ; 
} else if(preventImages) {

    ; __line = 48
    ; __append("<div class=\"notice\">")
    ; __append(escapeFn( __('hint.imageField.hiddenImages', { nrOfElements: nrOfImages }) ))
    ; __append("</div>")
    ; 
}

    ; __line = 50
    ; __append("</div>")
    ; 
}

    ; __line = 52
    ; __append("<div class=\"mediaContainer\">\n<div class=\"media\">")
    ; __line = 53
    ; 
if(!preventImages){
if(nrOfImages > 0) {
utils.forEach(model.dataJSON, function(image){

    ; __line = 57
    ; __append( include('../media/image/image', { resourceData: image, config: { context: 'assignment' }, model: { extendedButtonActionsGranted: model.extendedButtonActionsGranted } }) )
    ; 
});
} else if(fieldConfig.renderPlaceholder) {

    ; __line = 60
    ; __append( include('../media/image/image', { resourceData: {}, config: { context: 'assignment' }, model: { extendedButtonActionsGranted: model.extendedButtonActionsGranted } }) )
    ; 
}
}

    ; __line = 63
    ; __append("</div>\n</div>\n</div>")
    ; __line = 65
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=..\..\npm\frontend-controller\baseComponents\form\fields\image.ejs

}